export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/common/icon-sort-create-light-ceb7cc0c0c4a0e3c40d517c8cd6712ad.svg";